import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Row,
  Spin,
  Tag,
  Typography,
} from "antd";

import { LeftOutlined, SettingOutlined } from "@ant-design/icons";

import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import "../../../../../assets/styles/InterbankPlacement.css";
import {
  AccountFacility,
  AmountFormat,
  handleSubWalletAccountActionButtons,
} from "../../../../../components/facilities/WalletAccountFacility";
import MainLayout from "../../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
// import {
//   apiConfig,
//   labelConfig,
//   staticConfig,
// } from "../../contractbooking.config";
import { apiConfig, labelConfig, staticConfig } from "../wallet.config";

import Transactions from "../tabs/Transactions";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const DetailubWallet = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showInterestChecked, setShowInterestChecked] = useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });
  const [walletAccountDetails, setWalletAccountDetails] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [chargesList, setChargesList] = useState([]);
  const [transactionsList, setTransactionsList] = useState([]);
  const [savingsAccountData, setSavingsAccountData] = useState({});
  const [subWalletListData, setSubWalletListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [useForm] = Form.useForm();

  const walletAccountData = {};

  const tabList = [
    {
      key: "transactions",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Transactions</span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getWalletAccountById(state);
  }, []);

  const getWalletAccountById = (arg) => {
    const url = `${apiConfig.WalletAccount}/${arg.id}`;
    const params = {
      associations: "all",
      offset: 0,
      limit: 2,
      chargeStatus: "all",
    };

    let body = {
      session,
      params,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setTotalItems(objDetail?.savingsAccountData?.transactionSize);
        let tempSubWalletList = [];
        let tempChargesArray = [];
        let tempTransactionsArray = [];

        setWalletAccountDetails(objDetail);

        objDetail?.childWalletData?.forEach((element, i) => {
          tempSubWalletList.push({
            key: element?.id,
            id: element?.id,
            nubanNumber: element?.nuban || "-",
            parentName: element?.parentName || "-",
            name: element?.name || "-",
            // kycLevel: element?.kycLevel.value || "-",
          });
        });

        setSubWalletListData(tempSubWalletList);
        objDetail?.savingsAccountData?.transactions?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.date
              ? BOM.DateTime(element?.date, "only-date")
              : "-",
            transactionType: element?.transactionType
              ? element?.transactionType?.value
              : "-",
            amount: element.amount,
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
            transactionTypeDetail: element.transactionType,
          });
        });

        setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);
        setSavingsAccountData(objDetail?.savingsAccountData);

        setMenuProps({
          items: handleSubWalletAccountActionButtons(objDetail),
          onClick: (e) => {
            console.log(e);

            const item = handleSubWalletAccountActionButtons(objDetail).find(
              (element) => element.key === e.key,
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "unhold":
                  return unHold();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      actionLabel: item.label,
                      contractObj: objDetail,
                    },
                  });
              }
            }
          },
        });
        setIsLoading(false);
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    getWalletAccountById(offset, limit);
    setCurrentPage(1);
  };

  const transformedData = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Name",
          value: walletAccountDetails?.walletProductName ?? "-",
          isTag: true,
        },
        {
          name: "Product Currency",
          value:
            walletAccountDetails?.savingsAccountData?.currency?.displayLabel ??
            "-",
          isTag: true,
        },
        {
          name: "Activation Status",
          value: walletAccountDetails?.savingsAccountData?.status?.value ?? "-",
          isTag: true,
        },
        {
          name: "Created Date",
          // value: formatFullDate(walletAccountDetails?.submittedOnDate),
        },
      ],
    },

    {
      section: "Customer Eligibility",
      items: [
        {
          name: "KYC Level",
          value: walletAccountDetails?.kycLevel
            ? walletAccountDetails?.kycLevel?.value
            : "-",
          isTag: true,
        },
        {
          name: "Transaction Restriction",
          value: walletAccountDetails?.transactionRestrictionType
            ? walletAccountDetails?.transactionRestrictionType?.value
            : "-",
          isTagArray: true,
        },

        {
          name: "Customer Segment",
          value: walletAccountDetails?.customerSegmentType
            ? walletAccountDetails?.customerSegmentType?.value
            : "-",
          isTagArray: true,
        },
      ],
    },
    {
      section: "Account Parameters",
      items: [
        {
          name: "Account Name",
          value: walletAccountDetails?.name ? walletAccountDetails?.name : "-",
        },

        {
          name: "Statement Cycle",
          value: walletAccountDetails?.statementCycleType
            ? walletAccountDetails?.statementCycleType?.value
            : "-",
          isTagArray: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (walletAccountData[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 1,
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  function unHold() {
    console.log("hold");

    setIsLoading(true);
    const params = {
      command: "unblock",
    };
    const url = `${apiConfig.WalletAccount}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Wallet Account updated succesfully ");
          //STOP LOAD
          onRefresh(state);
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-sub-wallet", { state: { ...state } });
          onRefresh(state);
          setIsLoading(false);
        },
      },
    );
  }

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  function onCancel() {
    navigate("/detail-wallet-account", {
      state: { id: state.parentWalletAccountId },
    });
  }

  const contentListNoTitle = {
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        state={state}
        userData={userData}
        showInterestChecked={showInterestChecked}
        setShowInterestChecked={setShowInterestChecked}
        savingsAccountData={savingsAccountData}
        walletAccountDetails={walletAccountDetails}
        currentPage={currentPage}
        tableCount={tableCount}
        totalItems={totalItems}
        setCurrentPage={setCurrentPage}
        onRefresh={onRefresh}
      />
    ),
  };

  return (
    <MainLayout pageItems={staticConfig.detailSubWalletAccountBreadcrumbItems}>
      <TopContent
        pageTitle={labelConfig.detailSubWalletAccount}
        createPageTitle={labelConfig.detailSubWalletAccount}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>
            </Row>

            <AccountFacility
              status={walletAccountDetails?.savingsAccountData?.status?.value}
              name={walletAccountDetails?.savingsAccountData?.clientName}
              nubanNumber={walletAccountDetails?.nubanNumber}
              amount={
                walletAccountDetails?.savingsAccountData?.summary
                  ?.availableBalance
              }
              interest={walletAccountDetails?.maturityValue}
              currencyCode={
                walletAccountDetails?.savingsAccountData?.currency?.code
              }
              interestPerAnnum={walletAccountDetails?.interestRate}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData?.map((section, index) => (
                <Col style={{}}>
                  <Collapse
                    className="custom-collapse"
                    // expandIconPosition="start"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section?.items?.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index),
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
        <Card
          className="custom-transaction-tab"
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(DetailubWallet);
